import { render } from "./AdminUser.vue?vue&type=template&id=37f3f113"
import script from "./AdminUser.vue?vue&type=script&lang=js"
export * from "./AdminUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__